import * as React from 'react';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';

type Props = {
  id: string;
  text: string;
  children: React.ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
};

const TooltipOverlay: React.FC<Props> = ({ id, text, children, placement = 'bottom' }) => {
  return (
    <TooltipWrapper placement={placement} delayShow={100} tooltipId={id} message={text}>
      {children}
    </TooltipWrapper>
  );
};

export default TooltipOverlay;
